

















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class VCard extends Vue {
  @Prop({ default: () => "Titolo" }) readonly title!: string;
  @Prop({ default: true }) readonly showHeader!: boolean;

  get hasFooter() {
    return !!this.$slots.footer;
  }
}
